import React from "react";

import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import PropTypes from "prop-types";

import { StyledJobBox } from "../SimpleJobCard/SimpleJobCard";

function VerticalJobCards({ vacancies }) {
  if (isEmpty(vacancies)) {
    return null;
  }

  return (
    <>
      {vacancies.map((vacancy) => (
        <Link
          key={vacancy?.id}
          href={`/job/${vacancy?.id}`}
          passHref
          legacyBehavior
        >
          <StyledJobBox className="job-card border border-dark my-3 d-block p-3">
            <h3 className="job-card-title">{vacancy?.jobTitle}</h3>
            <div className="job-card-details">
              <p>{vacancy?.location?.city}</p>
              <p>{vacancy?.remuneration?.description}</p>
              <p>{vacancy?.validFrom}</p>
            </div>
          </StyledJobBox>
        </Link>
      ))}
    </>
  );
}

VerticalJobCards.defaultProps = {
  vacancies: [],
};

VerticalJobCards.propTypes = {
  vacancies: PropTypes.arrayOf,
};

export default observer(VerticalJobCards);
